import { useWindowDimensions } from '../hooks/useWindowDimensions';

export default function Opener() {
  const { width } = useWindowDimensions();

  return width >= 1280 ? (
    <div className='flex-1 flex flex-row w-full gap-10'>
      <div className='w-[20%] min-w-[250px] h-[92%] min-h-[800px] flex flex-col justify-center items-start pl-10 header-container'>
        <p className='text-[92px] font-serif font-thin tracking-tighter header-text'>
          save
        </p>
        <p className='text-[92px] font-serif font-thin tracking-tighter header-text'>
          the
        </p>
        <p className='text-[92px] font-serif font-thin tracking-tighter header-text'>
          date
        </p>

        <p className='text-[24px] font-serif font-thin tracking-tighter'>
          loren + robbie
        </p>
        <p className='text-[24px] font-serif font-thin tracking-tighter'>
          sep 20 2025
        </p>
      </div>

      <div className='min-w-[960px] w-[80%] h-[92%] min-h-[800px] flex flex-row mx-10 justify-center items-center gap-16 py-10'>
        <div className='h-full w-[25%] min-w-[250px] z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1594.jpg")] grayscale bg-cover bg-center rounded-full shadow-md' />
        </div>
        <div className='h-full w-[25%] min-w-[250px] z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1384.jpg")] grayscale bg-cover bg-center rounded-full shadow-md' />
        </div>
        <div className='h-full w-[25%] min-w-[250px] z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1430.jpg")] grayscale bg-cover bg-center rounded-full shadow-md' />
        </div>
      </div>
    </div>
  ) : width >= 768 ? (
    <div className='flex flex-col items-center'>
      <div className='flex flex-col items-center font-serif font-thin tracking-tighter header-text text-nowrap header-container'>
        <p className='text-[64px]'>save the date</p>
        <p className='text-[24px]'>loren + robbie</p>
        <p className='text-[24px]'>sep 20 2025</p>
      </div>

      <div className='min-w-[768px] w-full min-h-[600px] flex flex-row justify-center items-center mt-10 gap-8'>
        <div className='h-full w-[25%] min-w-[220px] z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1594.jpg")] grayscale bg-cover bg-center rounded-full shadow-md' />
        </div>
        <div className='h-full w-[25%] min-w-[220px] z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1384.jpg")] grayscale bg-cover bg-center rounded-full shadow-md' />
        </div>
        <div className='h-full w-[25%] min-w-[220px] z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1430.jpg")] grayscale bg-cover bg-center rounded-full shadow-md' />
        </div>
      </div>
    </div>
  ) : (
    <div className='flex flex-col items-center header-container font-serif font-thin tracking-tighter header-text text-nowrap w-full mt-2'>
      <p className='text-[40px]'>save the date</p>
      <p className='text-[16px] -mt-2'>loren + robbie</p>
      <p className='text-[16px] -mt-2'>sep 20 2025</p>

      <div className='w-full min-h-[700px] flex flex-col justify-around items-center mt-6 gap-4'>
        <div className='h-full min-w-full z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1594.jpg")] grayscale bg-cover bg-[0%_28%] shadow-md' />
        </div>
        <div className='h-full min-w-full z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1384.jpg")] grayscale bg-cover bg-center shadow-md' />
        </div>
        <div className='h-full min-w-full z-5'>
          <div className='h-full bg-no-repeat bg-[url("./assets/8T3A1430.jpg")] grayscale bg-cover bg-[0%_20%] shadow-md' />
        </div>
      </div>
    </div>
  );
}
